// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2-Z0M","header":"PatientBlock_header__oiob3","label":"PatientBlock_label__1y3ub","option":"PatientBlock_option__28HcH"};